module.exports = `fragment sub_site_variant on Contentstack_sub_site_variant {
	site
}`;